import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import Toggle from '@components/library/toggle/BaseToggle';
import Tooltip from '@components/common/tooltip/main';

const toggleSizes = {
  height: 26,
  width: 40,
  sliderDiameter: 24,
};

const ToggleContainer = ({
  handleUpdate,
  param,
  state,
}) => {
  const {
    internal,
    require_share_identification_setting,
    restrict_shares_setting,
  } = state;

  const toggleRowMap = {
    internal: {
      className: 'privacy-toggle',
      copy: t('Make link private'),
      display: !restrict_shares_setting,
    },
    require_identification: {
      className: 'require-id-toggle',
      copy: t('Require email address to access'),
      display: !restrict_shares_setting && !require_share_identification_setting && !internal,
    },
    view_only: {
      className: 'view-only-toggle',
      copy: t('Disable download functionality (view only mode)'),
      display: BFG.hasFeature('request_download_assets'),
      // tooltipCopy: t('When enabled, visitors may view assets, but must request access to download individual assets.'),
    },
    expires: {
      className: 'expires-toggle',
      copy: t('Expire link'),
      display: true,
    }
  };

  const { className, copy, display, tooltipCopy } = toggleRowMap[param];

  return (
    <CSSTransition
      in={display}
      timeout={300}
      unmountOnExit
    >
      {/* transition element can't have padding/margins - these properties can't transition,
          so extra parent container added here for JUST the transition,
          with padding/margin applied to the child element */}
      <div className="toggle-container-transition">
        <div className={`toggle-container ${className || ''} ${state[param] ? 'active' : ''}`}>
          <div className="copy-container">
            <h5>{copy}</h5>
            {tooltipCopy && (
              <Tooltip
                tooltipId={param}
                tooltipContent={tooltipCopy}
              >
                <span className="bff-tool-tip icon" />
              </Tooltip>
            )}
          </div>
          <Toggle
            className={className}
            isOn={state[param] || false}
            onToggle={() => handleUpdate({ type: param })}
            sizes={toggleSizes}
          />
        </div>
      </div>
    </CSSTransition>
  );
};

ToggleContainer.propTypes = {
  handleUpdate: PropTypes.func.isRequired,
  param: PropTypes.oneOf(['expires', 'internal', 'require_identification', 'view_only']).isRequired,
  state: PropTypes.shape({
    internal: PropTypes.bool,
    require_share_identification_setting: PropTypes.bool,
    restrict_shares_setting: PropTypes.bool,
  }).isRequired,
};

export default ToggleContainer;
